import React, { useState, useEffect } from "react";

import { useHistory, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import {
  Grid,
  Typography,
  Card,
  Divider,
  Box,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Autocomplete,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import { makeStyles } from "@mui/styles";
import AddIcon from "@mui/icons-material/Add";

const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function EditBarge() {
  const history = useHistory();
  const EmpId = localStorage.getItem("EmpId");
  let { id } = useParams();
  const data_params = { id: id };
  const [Barlist, setBarlist] = useState([]);
  const classes = useStyles();
  const [currency, setCurrency] = useState([]);
  // console.log(Station);
  const [MasterCost, setMasterCost] = useState([]);

  const [rows, setRows] = useState([]);
  function addRow() {
    const newRow = {
      id: rows?.slice(-1)[0]?.id ? rows?.slice(-1)[0]?.id + 1 : 1,
      CostId: "",
      CostPrice: 0,
      CurrencyId: "",
      CostPerContainer: true,
    };

    setRows([...rows, newRow]);
  }
  const deletehand = (i) => {
    const data = rows?.filter((e, id) => i !== id);
    setRows(data);
  };
  const getBargeData = async () => {
    try {
      const data = await api.post("api/barge/detail", data_params);
      // console.log(data.data);
      [].concat(data.data).map((res) => {
        setBarlist(res);
        setRows(res.BargeCostDetails);
        //   console.log(res);
      });
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    // GET request using axios inside useEffect React hook

    if (id) {
      getBargeData();
    }
    const getMasterCost = async () => {
      try {
        const res = await api.get(`/api/master/cost/Sale%20Order%20Cost`);
        setMasterCost(res?.data);

        //   setLog_data_length(3);
      } catch (e) {
        console.log(e);
      }
    };
    const getCurrency = async () => {
      try {
        const res = await api.get(`api/master/currency`);
        setCurrency(res?.data);

        //   setLog_data_length(3);
      } catch (e) {
        console.log(e);
      }
    };
    getCurrency();
    getMasterCost();
  }, []);

  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          เรือขนส่ง
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Barge
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Create Barge
            </Typography>
          </Grid>
        </Grid>
        {/* {console.log(Barlist?.Status)} */}
        <Formik
          enableReinitialize
          initialValues={{
            barge_code: Barlist?.BargeCode ? Barlist?.BargeCode : "",
            barge_name: Barlist?.BargeName ? Barlist?.BargeName : "",
            teus: Barlist?.TotalContainer ? Barlist?.TotalContainer : "",
            weight: Barlist?.Weight ? Barlist?.Weight : "",
            cyBay: Barlist?.CyBay ? Barlist?.CyBay : "",
            cyRows: Barlist?.CyRows ? Barlist?.CyRows : "",

            cyTires: Barlist?.CyTires ? Barlist?.CyTires : "",
            status: Barlist?.Status ? (Barlist?.Status === true ? 1 : 0) : 0,
          }}
          validate={(values) => {
            const errors = {};
            if (!values.barge_code || values.barge_code === "") {
              errors.barge_code = "Required";
            }
            if (!values.barge_name || values.barge_name === "") {
              errors.barge_name = "Required";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              if (id) {
                const data = {
                  id: id,
                  code: values.barge_code,
                  name: values.barge_name,
                  weight: values.weight,
                  teus: values.teus,
                  cyBay: values.cyBay,
                  cyRows: values.cyRows,
                  cyTires: values.cyTires,
                  status: values.status,
                  ModId: EmpId,
                  BargeCostDetail: rows,
                };

                api
                  .post("api/barge/update", data)
                  .then((respose) => {
                    const MySwal = withReactContent(Swal);

                    MySwal.fire({
                      icon: "success",
                      didOpen: () => {
                        MySwal.clickConfirm();
                      },
                    }).then(() => {
                      return MySwal.fire(
                        "สำเร็จ!",
                        "แก้ไขข้อมูลเรือสำเร็จ !",
                        "success"
                      ).then((result) => {
                        if (result.isConfirmed) {
                          getBargeData();
                        }
                      });
                    });
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              } else {
                const data = {
                  code: values.barge_code,
                  name: values.barge_name,
                  weight: values.weight,
                  teus: values.teus,
                  cyBay: values.cyBay,
                  cyRows: values.cyRows,
                  cyTires: values.cyTires,
                  BargeCostDetail: rows,
                  createId: EmpId,
                };

                api
                  .post("api/barge/create", data)
                  .then((respose) => {
                    const MySwal = withReactContent(Swal);

                    MySwal.fire({
                      icon: "success",
                      didOpen: () => {
                        MySwal.clickConfirm();
                      },
                    }).then(() => {
                      return MySwal.fire(
                        "สำเร็จ!",
                        "เพิ่มข้อมูลเรือสำเร็จ !",
                        "success"
                      ).then((result) => {
                        if (result.isConfirmed) {
                          history.push("/Setting/Barge");
                        }
                      });
                    });
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }

              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <Grid container>
                <Grid item xs={12} md={12}>
                  <div style={{ display: "flex" }}>
                    <TextField
                      name="barge_code"
                      label="Barge Code"
                      variant="outlined"
                      placeholder="Barge Code"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "50%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                      value={values.barge_code}
                      classes={{
                        root: !values.barge_code ? classes.customOutline : null,
                      }}
                      required
                    />

                    <TextField
                      name="barge_name"
                      label="Barge Name"
                      variant="outlined"
                      placeholder="Barge Name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "50%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                      value={values.barge_name}
                      classes={{
                        root: !values.barge_name ? classes.customOutline : null,
                      }}
                      required
                    />
                  </div>

                  <div style={{ display: "flex", marginTop: 10 }}>
                    <TextField
                      name="weight"
                      label="Weight"
                      variant="outlined"
                      placeholder="Weight"
                      onChange={handleChange}
                      // type="number"
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onBlur={handleBlur}
                      style={{ width: "50%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                      value={values.weight}
                    />
                    {errors.weight && touched.weight && errors.weight}
                    <TextField
                      name="teus"
                      label="Teus"
                      variant="outlined"
                      placeholder="Teus"
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "50%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                      value={values.teus}
                    />
                    {errors.teus && touched.teus && errors.teus}
                  </div>
                  <div
                    style={{ display: "flex", marginTop: 10, marginBottom: 10 }}
                  >
                    <TextField
                      name="cyBay"
                      label=" Bay"
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      variant="outlined"
                      placeholder=" Bay"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      InputLabelProps={{ shrink: true }}
                      style={{ marginRight: 5 }}
                      value={values.cyBay}
                      fullWidth
                    />
                    {errors.cyBay && touched.cyBay && errors.cyBay}
                    <TextField
                      name="cyRows"
                      label=" Rows"
                      variant="outlined"
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      placeholder=" Rows"
                      style={{ marginRight: 5 }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      InputLabelProps={{ shrink: true }}
                      value={values.cyRows}
                      fullWidth
                    />
                    {errors.cyRows && touched.cyRows && errors.cyRows}
                    <TextField
                      name="cyTires"
                      label="Tires"
                      variant="outlined"
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      placeholder="Tires"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      InputLabelProps={{ shrink: true }}
                      value={values.cyTires}
                      fullWidth
                    />
                    {errors.cyTires && touched.cyTires && errors.cyTires}
                  </div>
                  <FormControl style={{ marginTop: "10px" }} fullWidth>
                    <InputLabel id="select_status-label">Status</InputLabel>
                    <Select
                      name="status"
                      id="status"
                      value={values.status}
                      label="Status"
                      style={{
                        width: "50%",

                        marginBottom: "10px",
                      }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <MenuItem value={1}>Active</MenuItem>
                      <MenuItem value={0}>InActive</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}></Grid>
                <Button
                  type="button"
                  variant="contained"
                  // disabled={costType ? false : true}
                  style={{
                    background: "#80c340",
                    borderColor: "#80c340",
                    marginTop: "10px",
                  }}
                  onClick={addRow}
                >
                  <AddIcon /> Add
                </Button>
                <TableContainer sx={{ marginTop: 2, marginBottom: 2 }}>
                  <Table stickyHeader>
                    <TableRow>
                      <TableCell align="center" width="5%">
                        #
                      </TableCell>
                      <TableCell align="center" width="15%">
                        Charge
                      </TableCell>
                      <TableCell align="center" width="10%">
                        Quantity
                      </TableCell>
                      <TableCell align="center" width="15%">
                        Price
                      </TableCell>
                      <TableCell align="center" width="10%">
                        Currency
                      </TableCell>

                      {/* <TableCell align="center" width="15%">TaxTotal</TableCell> */}
                      <TableCell align="center" width="10%"></TableCell>
                    </TableRow>
                    {rows?.map((data, index) => {
                      return (
                        <TableBody key={index}>
                          <TableCell align="center">{index + 1}</TableCell>
                          <TableCell align="center">
                            {/* <FormControl fullWidth>
                        <InputLabel>Charge</InputLabel>
                        <Select
                          label="Charge"
                          value={data?.CostId || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => {
                            const io = rows?.map((v) => {
                              v.CostId =
                                v?.id === data?.id ? e.target.value : v?.CostId;
                              v.Cost =
                                v?.id === data?.id ? MasterCost.find(x => x?.CostId === e.target.value) : v?.Cost;
                              v.CostPrice =
                                v?.id === data?.id ? MasterCost.find(x => x?.CostId === e.target.value)?.CostPrice : +v?.CostPrice;
                              v.CurrencyId =
                                v?.id === data?.id ? MasterCost.find(x => x?.CostId === e.target.value)?.CurrencyId : v?.CurrencyId;

                              return v;
                            });

                            setRows([...io]);
                          }}
                        >
                          {MasterCost?.map((x) =>
                            <MenuItem value={x?.CostId}>{x?.CostName}</MenuItem>
                          )}
                        </Select>
                      </FormControl> */}
                            <Autocomplete
                              // freeSolo
                              fullWidth
                              options={MasterCost}
                              getOptionLabel={(option) => option?.CostName}
                              // renderOption={(props, option) => (
                              //   <Box component="li" {...props} key={option.EmpNo}>
                              //     {option?.firstname} {option?.lastname}</Box>
                              // )}

                              id="controlled-demo"
                              value={data?.Cost}
                              onChange={(event, newValue) => {
                                const io = rows?.map((v) => {
                                  v.Cost =
                                    v?.id === data?.id ? newValue : v?.Cost;
                                  v.CostId =
                                    v?.id === data?.id
                                      ? newValue?.CostId
                                      : v?.CostId;
                                  v.Cost =
                                    v?.id === data?.id
                                      ? MasterCost.find(
                                          (x) => x?.CostId === newValue?.CostId
                                        )
                                      : v?.Cost;
                                  v.CostPrice =
                                    v?.id === data?.id
                                      ? MasterCost.find(
                                          (x) => x?.CostId === newValue?.CostId
                                        )?.CostPrice
                                      : +v?.CostPrice;
                                  v.CurrencyId =
                                    v?.id === data?.id
                                      ? MasterCost.find(
                                          (x) => x?.CostId === newValue?.CostId
                                        )?.CurrencyId
                                      : v?.CurrencyId;

                                  return v;
                                });

                                setRows([...io]);
                              }}
                              selectOnFocus
                              clearOnBlur
                              handleHomeEndKeys
                              renderInput={(params) => (
                                <TextField {...params} label="Charge" />
                              )}
                            />
                          </TableCell>

                          <TableCell align="center">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={data?.CostPerContainer || ""}
                                  onChange={(e) => {
                                    const io = rows?.map((v) => {
                                      v.CostPerContainer =
                                        v?.id === data?.id
                                          ? e.target.checked
                                          : v?.CostPerContainer;

                                      return v;
                                    });

                                    setRows([...io]);
                                  }}
                                />
                              }
                              label="per CNTR"
                            />
                          </TableCell>
                          <TableCell align="center">
                            <TextField
                              label="Price"
                              value={data?.CostPrice || ""}
                              type="number"
                              onChange={(e) => {
                                const io = rows?.map((v) => {
                                  v.CostPrice =
                                    v?.id === data?.id
                                      ? +e.target.value
                                      : +v?.CostPrice;

                                  return v;
                                });

                                setRows([...io]);
                              }}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <FormControl fullWidth>
                              <InputLabel>Currency</InputLabel>
                              <Select
                                label="Currency"
                                value={data?.CurrencyId || ""}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => {
                                  const io = rows?.map((v) => {
                                    v.CurrencyId =
                                      v?.id === data?.id
                                        ? e.target.value
                                        : v?.CurrencyId;

                                    return v;
                                  });

                                  setRows([...io]);
                                }}
                              >
                                {currency?.map((x) => (
                                  <MenuItem value={x?.CurrencyId}>
                                    {x?.CurrencyCode}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </TableCell>

                          <TableCell align="center">
                            <Button
                              type="button"
                              variant="outlined"
                              style={{
                                color: "#80c340",
                                borderColor: "#80c340",
                              }}
                              onClick={() => deletehand(index)}
                            >
                              Delete
                            </Button>
                          </TableCell>
                        </TableBody>
                      );
                    })}
                  </Table>
                </TableContainer>
              </Grid>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <CircularProgress size={22} />}
                {!isSubmitting && "SAVE"}
              </Button>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
